/**
 * Атласы кадров героя способа Б (tools/art/bake_sheets.py): по клипу на сторону, кадр — прямоугольник и сдвиг от
 * стоп. Пиксели читаются один раз в Uint32 (ABGR, как кадр pixelfx) — рисование без canvas.
 */
export interface SpriteFrame {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
  readonly ox: number;
  readonly oy: number;
}

export interface Clip {
  readonly frames: readonly SpriteFrame[];
  readonly width: number;
  readonly pixels: Uint32Array;
}

export const CLIPS = [
  "fighting-idle",
  "fast-run",
  "punch-combo",
  "uppercut",
  "mma-kick",
  "flying-knee-punch-combo",
  "flip-kick",
  "backflip",
  "receiving-a-big-uppercut",
  "getting-up",
  "lead-jab",
  "side-kick",
  "crouch-idle",
  "crouch-jab",
  "walking",
  "walking-backwards",
  "running-slide",
  "soccer-tackle",
  "center-block",
  "kicking",
  "hurricane-kick",
  "roundhouse-kick",
  "dive-roll",
  "falling-to-roll",
  "inverted-double-kick-to-kip-up",
  "quick-180-turn",
  "elbow-punch",
  "elbow-uppercut-combo",
  "drop-kick",
] as const;
export type ClipName = (typeof CLIPS)[number];

export type HeroAtlas = ReadonlyMap<ClipName, Clip>;

async function loadClip(base: string, name: ClipName): Promise<Clip> {
  const meta = (await (await fetch(`${base}/${name}.json`)).json()) as { frames: number[][] };
  const image = new Image();
  image.src = `${base}/${name}.png`;
  await image.decode();
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas 2D недоступен");
  context.drawImage(image, 0, 0);
  const data = context.getImageData(0, 0, image.width, image.height).data;
  return {
    frames: meta.frames.map(([x = 0, y = 0, w = 0, h = 0, ox = 0, oy = 0]) => ({ x, y, w, h, ox, oy })),
    width: image.width,
    pixels: new Uint32Array(data.buffer.slice(0)),
  };
}

/** Атлас стороны героя: все клипы; ошибка загрузки — null, игра рисует запасного манекена. */
export async function loadAtlas(hero: string, side: "p1" | "p2"): Promise<HeroAtlas | null> {
  try {
    const base = `./sprites/${hero}/${side}`;
    const clips = await Promise.all(CLIPS.map(async (name) => [name, await loadClip(base, name)] as const));
    return new Map(clips);
  } catch {
    return null;
  }
}
